import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function TermsPage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-white pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">服务条款</h1>
            <p className="text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
              使用我们的服务前，请仔细阅读以下条款和条件
            </p>
          </div>
        </section>

        {/* Terms Content */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="mb-8">
                <p className="text-gray-600 text-lg">
                  最后更新时间：2025年1月1日
                </p>
              </div>

              <div className="space-y-12">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">1. 接受条款</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      欢迎使用星允信息（"我们"、"公司"）提供的服务。通过访问或使用我们的网站、产品或服务，您同意受本服务条款（"条款"）的约束。
                    </p>
                    <p>
                      如果您不同意这些条款，请不要使用我们的服务。我们保留随时修改这些条款的权利。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">2. 服务描述</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们提供以下服务：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li><strong>Adobe PDF Library SDK</strong>：用于PDF文档处理的开发工具包</li>
                      <li><strong>Adobe PDF Converter</strong>：文档格式转换服务</li>
                      <li><strong>PDF表单处理器</strong>：智能表单识别和处理工具</li>
                      <li><strong>企业文档平台</strong>：综合文档管理解决方案</li>
                      <li><strong>PDF云端API</strong>：基于云的PDF处理接口</li>
                      <li><strong>PDF安全套件</strong>：文档安全和权限管理工具</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">3. 用户账户</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      使用某些服务可能需要创建账户。您同意：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>提供准确、完整的注册信息</li>
                      <li>维护账户信息的准确性</li>
                      <li>保护账户密码的安全</li>
                      <li>对账户下的所有活动负责</li>
                      <li>立即通知我们任何未经授权的使用</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">4. 使用限制</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      您同意不会：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>违反任何适用的法律或法规</li>
                      <li>侵犯他人的知识产权</li>
                      <li>传输恶意软件或有害代码</li>
                      <li>尝试未经授权访问我们的系统</li>
                      <li>干扰或破坏服务的正常运行</li>
                      <li>进行反向工程、反编译或反汇编</li>
                      <li>将服务用于竞争目的</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">5. 知识产权</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们的服务及其所有内容、功能和特性均为我们或我们的许可方所有，受版权、商标和其他知识产权法保护。
                    </p>
                    <p>
                      您被授予有限的、非独占的、不可转让的许可来使用我们的服务，仅限于个人或内部业务用途。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">6. 付费服务</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      某些服务可能需要付费。对于付费服务：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>费用将在购买时明确显示</li>
                      <li>付款到期时必须及时支付</li>
                      <li>逾期付款可能导致服务暂停</li>
                      <li>退款政策将根据具体服务条款执行</li>
                      <li>价格可能会发生变化，但会提前通知</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">7. 隐私和数据保护</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们重视您的隐私。我们的隐私政策详细说明了我们如何收集、使用和保护您的信息。使用我们的服务即表示您同意我们的隐私政策。
                    </p>
                    <p>
                      您保留对您提供给我们的数据的所有权利。我们仅在提供服务所需的范围内使用您的数据。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">8. 服务可用性</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们努力保持服务的高可用性，但不能保证服务不会中断。服务可能因以下原因暂时不可用：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>计划维护和更新</li>
                      <li>紧急维修</li>
                      <li>网络或硬件故障</li>
                      <li>不可抗力事件</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">9. 免责声明</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们的服务按"现状"提供，不提供任何明示或暗示的保证，包括但不限于：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>适销性保证</li>
                      <li>特定用途适用性保证</li>
                      <li>不侵权保证</li>
                      <li>持续可用性保证</li>
                    </ul>
                    <p>
                      您使用我们的服务需自担风险。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">10. 责任限制</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      在法律允许的最大范围内，我们对以下损失不承担责任：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>间接、偶然或后果性损失</li>
                      <li>利润损失或业务中断</li>
                      <li>数据丢失或损坏</li>
                      <li>第三方索赔</li>
                    </ul>
                    <p>
                      我们的总责任不超过您在过去12个月内支付给我们的费用。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">11. 赔偿</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      您同意就因您违反本条款或使用我们的服务而产生的任何索赔、损失或费用，对我们进行赔偿和免责。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">12. 终止</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们可能在以下情况下终止或暂停您的服务：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>违反本服务条款</li>
                      <li>未按时支付费用</li>
                      <li>从事非法或有害活动</li>
                      <li>长期不活跃</li>
                    </ul>
                    <p>
                      终止后，您使用服务的权利将立即停止。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">13. 争议解决</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      因本条款产生的任何争议应首先通过友好协商解决。如协商不成，争议应提交至我们所在地有管辖权的法院解决。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">14. 适用法律</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      本条款受中华人民共和国法律管辖，并按其解释。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">15. 条款修改</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们保留随时修改本条款的权利。重大修改将通过以下方式通知您：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>在网站上发布通知</li>
                      <li>发送电子邮件通知</li>
                      <li>在服务中显示弹窗</li>
                    </ul>
                    <p>
                      继续使用服务即表示您接受修改后的条款。
                    </p>
                  </div>
                </div>

                <div className="bg-teal-50 rounded-xl p-8 mt-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">联系我们</h2>
                  <div className="space-y-2 text-gray-700">
                    <p>
                      如果您对本服务条款有任何疑问，请通过以下方式联系我们：
                    </p>
                    <div className="mt-4 space-y-2">
                      <p><strong>邮箱：</strong> legal@documogul.com</p>
                      <p><strong>电话：</strong> 400-838-9650</p>
                      <p><strong>地址：</strong> 中国广州市天河区灵山东路5号2层</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}